/*
  Kollektionssider: antal produkter + filterknap (mobil) ved kollektionens titel
  (snippets/dms-collection-toolbar.liquid).

  - Titlen kan ligge i temaets kollektionsbanner (har allerede .dms-hero-row) eller i en
    rich-text-sektion over produkterne. I sidstnævnte tilfælde flyttes værktøjslinjen fra
    produktgitteret op ved siden af titlen.
  - Antallet spejler temaets #ProductCount, som opdateres når der filtreres (facets.js).
*/
(function () {
  if (window.__dmsCollectionToolbar) return;
  window.__dmsCollectionToolbar = true;

  function sync() {
    var source = document.getElementById("ProductCount");
    var text = source ? source.textContent.trim() : "";
    if (!text) return;
    document.querySelectorAll("[data-dms-product-count]").forEach(function (el) {
      if (el.textContent.trim() !== text) el.textContent = text;
    });

    // Knappen i filterskuffen: "Vis 5 produkter" / "Vis 1 produkt"
    var match = text.match(/\d[\d.]*/);
    if (match) {
      var n = parseInt(match[0].replace(/\./g, ""), 10);
      var label = "Vis " + match[0] + (n === 1 ? " produkt" : " produkter");
      document.querySelectorAll("[data-dms-show-results]").forEach(function (el) {
        if (el.textContent !== label) el.textContent = label;
      });
    }
  }

  function placeToolbar() {
    var slot = document.querySelector(".dms-toolbar-slot");
    if (!slot) return;
    var toolbar = slot.querySelector(".dms-collection-toolbar");

    // Banneret har allerede sin egen værktøjslinje
    if (document.querySelector(".dms-hero-row .dms-collection-toolbar")) {
      slot.remove();
      return;
    }

    // Find titlen i en sektion før produktgitteret
    var gridSection = slot.closest(".shopify-section");
    var heading = null;
    var section = gridSection ? gridSection.previousElementSibling : null;
    while (section && !heading) {
      heading = section.querySelector("h1");
      section = section.previousElementSibling;
    }
    if (!heading || !toolbar) {
      slot.classList.add("is-visible");
      return;
    }

    var row = document.createElement("div");
    row.className = "dms-hero-row";
    heading.parentNode.insertBefore(row, heading);
    row.appendChild(heading);
    row.appendChild(toolbar);
    slot.remove();
  }

  function init() {
    placeToolbar();
    sync();
    new MutationObserver(sync).observe(document.getElementById("ProductGridContainer") ? document.querySelector(".page-layout-main-content") || document.body : document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
